import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'

import { SearchPanelContainer } from '@components/Search'
import FilterGroup from '@components/FilterGroup'
import { DatePickerRange } from '@components/DatePicker'

class PaymentsFilterPanel extends Component {
  static propTypes = {
    paymentStore: PropTypes.object
  }

  searchOnEnter = e => {
    if (e.keyCode === 13) {
      this.props.paymentStore.filter()
    }
  }

  filterByStartDate = date => {
    if (!date) return
    const { paymentStore } = this.props
    paymentStore.query.startDate = date
    paymentStore.filter()
  }

  filterByEndDate = date => {
    if (!date) return
    const { paymentStore } = this.props
    paymentStore.query.endDate = date
    paymentStore.filter()
  }

  onClearSearch = () => {
    this.props.paymentStore.clearSearch()
  }

  render () {
    const { query } = this.props.paymentStore

    return (
      <SearchPanelContainer
        extrathin
        searchTitle='Filter'
        onClearSearch={this.onClearSearch}
      >
        <FilterGroup label='Select date range'>
          <DatePickerRange
            dateOnly
            fromDate={query.startDate}
            toDate={query.endDate}
            onFromChange={this.filterByStartDate}
            onToChange={this.filterByEndDate}
          />
        </FilterGroup>
      </SearchPanelContainer>
    )
  }
}

export default observer(PaymentsFilterPanel)
